﻿export default class HousingProductType {

  static Spec() {
    return new HousingProductType('spec');
  }

  static Plan() {
    return new HousingProductType('plan');
  }

  static Community() {
    return new HousingProductType('community');
  }

  static BasicListing() {
    return new HousingProductType('basicListing');
  }

  constructor(type) {
    this.type = type;
  }

  getName() {
    return this.type;
  }
}
